import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class PondIntimationService extends BaseService{

  constructor(private http: HttpClient, tokenService: TokenService) {
    super(tokenService);
}
  // GET SERVICES
  getAppIdByFarmerId(farmerId){
    // return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetAppIDByFarmerID?FarmerID=${farmerId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetAppIDByFarmerID?FarmerID=${farmerId}`);
  }

  GetFarmerPondIntimation(farmerID: any) {
    // return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetFarmerPondIntimation?appID=${appId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetFarmerPondIntimation?farmerID=${farmerID}`);
  }
  
  //POST SERVICES
  updateFarmerPondIntimation(farmerIntimationBody: any) {
    // return this.http.post(`${environment.apiUrl}FarmerApplication/UpsertFarmerPondIntimation`, farmerIntimationBody, { headers: this.buildHeaders() });
    return this.http.post(`${environment.apiUrl}FarmerApplication/UpsertFarmerPondIntimation`, farmerIntimationBody);
  }

}
